// extracted by mini-css-extract-plugin
export default {"btn":"LeftArrow_btn__3+yyA","btnLeft":"LeftArrow_btnLeft__nNYhT"};